export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_10.8c77b318.jpg";